import React from 'react';
import "./settings.css";
import { Button } from 'devextreme-react';



export default class Settings extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

        };

        this.onUpdateCurrencyClick = this.onUpdateCurrencyClick.bind(this);
        this.onClearDataBaseClick = this.onClearDataBaseClick.bind(this);
    }

    onUpdateCurrencyClick(e) {
        var tokenKey = "accessToken";

        var token = sessionStorage.getItem(tokenKey);

        var currencyData = {
            dateFrom: null,
            dateTo: null
        }

        fetch('api/main/UpdateCurrency', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify(currencyData)
        })
            .then(response => response.json())
            .then(data => {

            });
    }

    onClearDataBaseClick() {
        var tokenKey = "accessToken";

        var token = sessionStorage.getItem(tokenKey);

        var clearDatabaseData = {
            dateFrom: null,
            dateTo: null
        }

        fetch('api/main/clearDatabase', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify(clearDatabaseData)
        })
            .then(response => response.json())
            .then(data => {

            });
    }

    render() {
        return (
            <div>
                <Button
                    className="positionGrid"
                    text={'Обновить курсы'}
                    type={'default'}
                    width={200}
                    onClick={this.onUpdateCurrencyClick}
                />
                <Button
                    className="positionGrid"
                    text={'Очистить базу'}
                    type={'default'}
                    width={200}
                    onClick={this.onClearDataBaseClick}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/containers/settings/settings.jsx